import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return this.formatDate(this.convertUtcToLocalTime(value));
    }

    return null;
  }

  formatDate(date: Date) {
    return date.toLocaleDateString(this.getLocale());
  }

  convertUtcToLocalTime(utcTime: string): Date {
    // 08072019 - Only for Athena the input was not UTC string and needs to convert to a Date object
    const localTimeZone = _.split(utcTime, 'T');
    const yearMonthDateArr = _.split(localTimeZone[0], '-');
    // Expected 2019-08-30, Months are 0 index based for Date().
    return yearMonthDateArr.length === 3 ? new Date(_.toNumber(yearMonthDateArr[0]),
      _.toNumber(yearMonthDateArr[1]) - 1, _.toNumber(yearMonthDateArr[2])) : new Date();
  }

  getLocale(): string {
    const europeCountryCodes = ['AL', 'AD', 'AT', 'AZ', 'BY', 'BE', 'BA', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'GE', 'DE',
      'GR', 'HU', 'IS', 'IE', 'IT', 'KZ', 'XK', 'LV', 'LI', 'LT', 'LU', 'MK', 'MT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RO',
      'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TR', 'UA', 'GB', 'VA' ];
    return _.includes(europeCountryCodes, navigator.language.substring(3, 5)) ? 'en-GB' : 'en-US';
  }

}
